import { DATA_SOURCE_OPTIONS } from '../utils/ledgerLineItems';

const CHANNEL_LABELS = {
  web: 'Web', phone: 'Phone', counter: 'Counter', mail: 'Mail', kiosk: 'Kiosk', app: 'App', other: 'Other',
};

export const PAYMENTS_FILTER_IDS = ['venue_ownership_id', 'payment_method', 'channel', 'data_source'];

export const buildPaymentsFilterGroups = (filterOptions = {}, venueOwnerships = []) => [
  {
    id: 'venue',
    label: 'Venue',
    filters: [
      {
        id: 'venue_ownership_id',
        label: 'Venue',
        type: 'checkbox',
        options: (venueOwnerships || []).map(o => ({ value: String(o.id), label: o.name })),
      },
    ],
  },
  {
    id: 'payment',
    label: 'Payment',
    filters: [
      {
        id: 'payment_method',
        label: 'Payment Method',
        type: 'checkbox',
        options: (filterOptions.payment_method_options || []).map(o => ({ value: o, label: o })),
      },
      {
        id: 'channel',
        label: 'Channel',
        type: 'checkbox',
        options: (filterOptions.channel_options || []).map(o => ({ value: o, label: CHANNEL_LABELS[o] || o })),
      },
    ],
  },
  {
    id: 'data',
    label: 'Data',
    filters: [
      { id: 'data_source', label: 'Origin', type: 'checkbox', options: DATA_SOURCE_OPTIONS },
    ],
  },
];
